import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpEventType } from '@angular/common/http';
import { BillingService } from '../../../../services/billing.service';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { MatSnackBar } from '@angular/material';
import { TransactionList } from '../../../../models/transaction.model';

@Component({
    selector: 'dialog-federal-government-export-transaction',
    templateUrl: 'dialog.exporttransaction.html',
    styleUrls: ['dialog.exporttransaction.css']
})
export class ExportFederalGovernmentTransactionDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    disabledDownload: boolean = false;
    errorMessage: string = '';
    dueDate: Date = new Date();
    reportDate: Date = new Date();
    modifiedBookingDate: Date = new Date();
    totalAmount: string = '0.00';
    janEncryption: boolean = true;
    isModifiedBookingDate: boolean = false;
    jan_Transaction: TransactionList;

    //Download message
    downloadMessage: string = '';
    downloadFileProgress: number = 0;

    constructor(public dialogRef: MatDialogRef<ExportFederalGovernmentTransactionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private billingService: BillingService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.jan_Transaction = {
            agentCode: this.data.agentCode,
            accOffCode: this.data.accOffCode,
            warrantNumber: this.data.warrantNo,
            recordStatus: this.data.recordStatus,
            paymentFrom: this.data.paymentFrom,
            paymentTo: this.data.paymentTo,
            sqlPNR: this.data.sqlPNR,
            invoiceNo: this.data.invoiceNo,
            pukalNo: null,
            travelAgent: null,
            page: null,
            isSplitBooking: null,
            PageSize: null,
            transactionType: null
        }


        let export_init_sub = this.billingService.getInitialExportTransaction(this.jan_Transaction)
            .subscribe(
                (data) => {
                    if (typeof (data) === 'string' && data !== '0.00') {
                        this.totalAmount = data;
                    } else {
                        this.totalAmount = '0.00';

                        this.disabledDownload = true; //disabled download button & show message
                        this.downloadMessage = 'Transaction record is empty.';
                    }
                },
                error => this.errorMessage = <any>error
            );

        //Adds into array for each subscribe
        this.allSub.push(export_init_sub);
    }

    dueDateOnChange(date: Date) {
        this.dueDate = date;
    }

    reportDateOnChange(date: Date) {
        this.reportDate = date;
    }

    closeDialog(): void {
        this.dialogRef.close('Close');
    }

    cbOnChange(e): void {
        // console.log(e.checked);
        // console.log(this.jan_Transaction)
    }

    modifiedBookingDateOnChange(date: Date) {
        this.modifiedBookingDate = date;
    }

    cbModifiedBookingDateOnChange(e): void {
        this.isModifiedBookingDate = e.checked;
    }

    downloadTransaction(): void {
        let cfm = confirm("Are you sure you want to download the PTJ Billing Files?");

        if (cfm) {
            this.disabledDownload = true;

            let download = {
                JANTransaction: this.jan_Transaction,
                DueDate: this.dueDate,
                ReportDate: this.reportDate,
                JanEncryption: this.janEncryption,
                IsModifiedBookingDate: this.isModifiedBookingDate,
                ModifiedBookingDate: this.modifiedBookingDate
            }

            let jan_transac_sub = this.billingService.downloadFederalGovBilling(download)
                .subscribe(
                    (event) => {
                        if (event.type === HttpEventType.UploadProgress) {
                            this.downloadMessage = 'System is processing the PTJ Billing Files....';
                        } else if (event.type === HttpEventType.DownloadProgress) {
                            this.downloadMessage = 'Begin downloading the PTJ Billing Files....';
                            // Compute and show the % done:
                            this.downloadFileProgress = Math.round(100 * event.loaded / event.total);
                        }
                        else if (event.type === HttpEventType.Response) {
                            let blob = new Blob([event.body], { type: 'application/zip' });
                            saveAs(blob, 'PTJ Billing.zip');

                            this.dialogRef.close({
                                status: 1,
                                message: 'Download completed.'
                            });
                        }
                    },
                    error => {
                        this.errorMessage = <any>error;
                        this.disabledDownload = false;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(jan_transac_sub);
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}